<template>
    <div>
        layout-default
    </div>
</template>

<script>
export default {
    name: 'layout-default-v2',
};
</script>

<style scoped lang="less">
@import '~theme';

.layout-default {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    width: 100%;

    &__header {
        width: 100vw;
        max-width: @content-max-width;

        flex: 0 0 auto;

        z-index: 3;

        .cms-toolbar-expanded & {
            top: @container-cms-height;
        }
        &._transparent {
            margin-bottom: -@container-header-height;
            .cms-toolbar-expanded & {

            }
        }
    }
    &__main {
        position: relative;
        z-index: 2;

        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;

        &-content {
            position: relative;
            // width: 100%;
            // max-width: @content-max-width;
            // margin: 0 auto;
        }
    }
    &__footer {
        position: relative;
        z-index: 1;

        flex: 0 0 auto;
    }
}
</style>
